import { useContext, useLayoutEffect, useRef, useState } from "react";
import { ForMnSteps, BurgerButtonBig, ButtonRound, DropdownInfo, HeaderBig, LearnMore, SignupBox } from "../common/Common";
import './ForMn.css';
import { LocaleContext } from "../common/App";
import { Footer } from "./WebsiteCommon";
import { useIndexUpdate, useNavigateSmart } from "../common/hooks";
import { WebsiteContext } from "./WebsiteApp";
import { UserType } from "../common/enums.mjs";

export function ForMn(props) {
    const locale = useContext(LocaleContext);
    const website = useContext(WebsiteContext);

    const navigate = useNavigateSmart();

    useIndexUpdate(props.indexUpdate, locale);

    return (
        <div className="for_mn head_img">
            <img className="img_width" src="/customer/images/mn_1.jpg" alt={locale.msgs.MN_IMG_1_ALT_TEXT}></img>
            <div className="text_box">
                <h1 className="text_big_big head_after_img">{locale.msgs.FOR_MN_LONG}</h1>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.FOR_MN_DESCR}}></div>

                <div className="text_big_big margin_top_middle">{locale.msgs.HOW_BROKERAGE_WORKS}</div>
            </div>

            <img className="img_width margin_top_low_low" src="/customer/images/mn_2.jpg" alt={locale.msgs.MN_IMG_2_ALT_TEXT}></img>

            <div className="text_box">
                <ForMnSteps/>
            </div>

            <div className="text_box">
                <div className="text_big_big margin_top_middle">{locale.msgs.AMOUNT_OF_WAGE}</div>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.AMOUNT_OF_WAGE_DESCR}}></div>

                <div className="text_big_big margin_top_middle">{locale.msgs.WAY_OF_EMPLOYMENT}</div>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.WAY_OF_EMPLOYMENT_DESCR}}></div>

                <div className="margin_top_high">
                    <SignupBox header={locale.msgs.FIND_JOB_2} descr={locale.msgs.FIND_JOB_DESCR_MN}
                            onClick={() => {
                                website.setRegisterInfo({...website.registerInfo, "userType": UserType.NANNY});
                                navigate("/register/");
                            }} />
                </div>
            </div>
            
            <img className="img_width margin_top_high margin_bottom_high" src="/customer/images/mn_3.jpg" alt={locale.msgs.MN_IMG_3_ALT_TEXT}></img>

            {/*
            <div className="text_box_gray margin_bottom_high">
                <div className="text_big_big">{locale.msgs.OUR_ACADEMY}</div>
                <div className="text">{locale.msgs.OUR_ACADEMY_DESCR}</div>
                <LearnMore href="/login/"/>
            </div>
            */}

            <Footer />
        </div>
    );
}
